<template>
    <div>
        <v-btn
            v-if="!noButton"
            :color="buttonColor"
            :round="buttonRound"
            :large="buttonLarge"
            @click="onPay"
            :loading="loading"
            >{{ 'Pay' | translation }}</v-btn
        >
    </div>
</template>

<script>
import { PayeverPaymentType } from './config';
import { mapMutations, mapState, mapActions } from 'vuex';
import module from './store/payever';

const moduleName = 'PayeverPaymentType';

export default {
    name: moduleName,
    props: {
        noButton: Boolean,
        buttonLarge: Boolean,
        buttonRound: Boolean,
        buttonColor: {
            type: String,
            default: 'primary',
        },
    },
    created() {
        let query = this.$route.query;
        if (query.transactionId && query.orderId) {
            this.doPayment(query.transactionId, query.orderId, query.paymentId);
        }
    },
    computed: {
        ...mapState(moduleName, {
            loading: state => state.loading,
        }),
    },
    methods: {
        ...mapMutations(moduleName, ['setLoading']),
        ...mapMutations('Payment', ['setError']),
        ...mapActions(moduleName, ['createPayment', 'executePayment']),
        onPay() {
            this.$order.getOrder().then(order => {
                if (order && order.id) {
                    this.createPayment({
                        orderId: order.id,
                        transactionId: order.transaction_id,
                        shippingAddress: this.shippingAddress,
                    });
                } else {
                    this.setError('Order not created, please try again later.');
                }
            });
        },
        doPayment(transactionId, orderId, paymentId) {
            this.executePayment({ transactionId, orderId, paymentId }).then(result => {
                if (result && result.success) {
                    console.log(result);
                    this.$router.replace({
                        ...this.$route,
                        query: {},
                    });

                    if (result.status === 'pending') {
                        this.$emit('received', { transaction_id: transactionId, paid: false });
                    } else {
                        this.$emit('success', { transaction_id: transactionId });
                    }
                } else {
                    this.$emit('cancel', { transaction_id: transactionId });
                    this.setLoading(false);
                }
            });
        },
    },
    install(Vue) {
        if (!Vue.$store.state[moduleName]) {
            Vue.$store.registerModule(moduleName, module);
        }
        Vue.component(moduleName, this);
        Vue.$store.commit('Payment/addPaymentType', new PayeverPaymentType());
    },
};
</script>
